import { createSlice } from '@reduxjs/toolkit';

const initialState = '';

const horaServidorStateSlice = createSlice({
	name: 'horaServidorState',
	initialState,
	reducers: {
		setHoraServidor: (state, action) => {
			return action.payload;
		}
	}
});

export const { setHoraServidor } = horaServidorStateSlice.actions;

export default horaServidorStateSlice.reducer;
